module.exports = __webpack_public_path__ + "img/browser-opera-logo.e71d2f6e.webp";